export const getStockAlertThresholdForSite = (
  productData: {
    minStockAlert?: number;
    minStockAlertBySite?: Record<string, number>;
  },
  siteId?: string
): number => {
  const globalThreshold = Math.max(0, Number(productData.minStockAlert ?? 0));
  if (!siteId) return globalThreshold;

  const bySite = productData.minStockAlertBySite || {};
  const siteThreshold = Number(bySite[siteId]);
  if (!Number.isFinite(siteThreshold)) {
    return globalThreshold;
  }

  return Math.max(0, siteThreshold);
};

